import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Wraps Text block output; toggles visibility when the selected variant is sold out.
 * Matches product-inventory / variant:update handling.
 */
class SoldOutText extends HTMLElement {
  /** @type {HTMLElement | null} */
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#section = null;
  }

  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    if (event.detail.data.instant) {
      const variant = event.detail.resource;
      if (variant == null) {
        this.hidden = true;
      } else {
        this.hidden = !!variant.available;
      }
      return;
    }

    const id = this.dataset.productId || '';
    const next = event.detail.data.html.querySelector(`sold-out-text[data-product-id="${id}"]`);

    if (!next) return;

    morph(this, next, { childrenOnly: true });
    this.hidden = next.hidden;
  };
}

if (!customElements.get('sold-out-text')) {
  customElements.define('sold-out-text', SoldOutText);
}
